import type {QueryParams} from '@jetbrains/teamcity-ui/dist/utils'

import type {AppThunk} from '../../../../../../../actions/types'
import type {LoadedEndpoints} from '../../../../../../../routes/loadEndpoint'
import {toBuildId, BuildPageTabNamesEnum} from '../../../../../../../types'
import {preloadBuildArtifactsTree} from '../../../../../../common/BuildArtifactsTree/BuildArtifactsTree.preload'

export const preloadJobDetails =
  ({job, tab, showAll}: QueryParams): AppThunk<LoadedEndpoints> =>
  dispatch => {
    const endpoints: LoadedEndpoints = []
    switch (tab) {
      case BuildPageTabNamesEnum.ARTIFACTS:
        endpoints.push(
          ...dispatch(preloadBuildArtifactsTree(toBuildId(job ?? ''), showAll === 'true')),
        )
        break
      default:
    }
    return endpoints
  }
